const React = require("react")
const Users = ({ ...props }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.7925 9.52221C21.5825 10.3122 21.5825 11.5931 20.7925 12.3832C20.0025 13.1732 18.7216 13.1732 17.9316 12.3832C17.1415 11.5931 17.1415 10.3122 17.9316 9.52221C18.7216 8.73218 20.0025 8.73218 20.7925 9.52221"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2026 5.91236C15.4191 7.12884 15.4191 9.10115 14.2026 10.3176C12.9861 11.5341 11.0138 11.5341 9.79732 10.3176C8.58084 9.10116 8.58084 7.12885 9.79732 5.91236C11.0138 4.69588 12.9861 4.69588 14.2026 5.91236"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.06848 9.52221C6.85851 10.3122 6.85851 11.5931 6.06848 12.3832C5.27845 13.1732 3.99756 13.1732 3.20753 12.3832C2.4175 11.5931 2.4175 10.3122 3.20753 9.52221C3.99756 8.73218 5.27845 8.73218 6.06848 9.52221"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 18.9983V17.9023C23 16.5213 21.881 15.4023 20.5 15.4023H19.699"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 18.9983V17.9023C1 16.5213 2.119 15.4023 3.5 15.4023H4.301"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.339 18.9994V17.3984C17.339 15.4654 15.772 13.8984 13.839 13.8984H10.16C8.227 13.8984 6.66 15.4654 6.66 17.3984V18.9994"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

module.exports = {
  Users
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/menu/icons/users.js